import clsx from 'clsx'

const PileInput: React.FC<any> = props => {
  const { onChange, field, isView } = props.cell.column

  if (props.row.original.quantity === 0 || props.row.original.availableForShipment === 0) {
    return null
  }

  if (isView) {
    return null
  }

  return (
    <div className='text-end'>
      <input
        disabled={isView}
        type='text'
        className={clsx('form-control form-control-sm', {
          'is-invalid': (props.cell.value ?? 0) > props.row.original.availableForShipment,
        })}
        value={props.cell.value ?? ''}
        style={{ width: '200px', maxWidth: '100%', display: 'inline-block' }}
        onChange={(e: any) => onChange(props.row.original.index, field, e.target.value)}
      />
      {(props.value ?? 0) > props.row.original.availableForShipment && (
        <div className='fv-plugins-message-container'>
          <span role='alert' className='fv-help-block'>
            จำนวนที่ขนส่งต้องน้อยกว่าจำนวนที่สามารถขนส่งได้
          </span>
        </div>
      )}
    </div>
  )
}

export default PileInput
